import * as React from "react";
import { SVGProps } from "react";

const BestWaterAppIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    width={40}
    height={40}
    viewBox="0 0 180 180"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="m2.5 2.5h175v175h-175z" fill="#fff" />
    <path d="m2.5 2.5h175v175h-175z" stroke="#fff" strokeWidth="5" />
    <g fill="#ff88bd">
      <path d="m90 152.681c25.177 0 45.586-20.542 45.586-45.883 0-16.9815-9.171-31.8105-22.795-39.745v-.0038l-29.5231-17.1576v15.804l22.5481 13.1043.175.1033h.003l.274.1606c4.506 2.6843 8.297 6.447 11.033 10.9362 2.978 4.8869 4.692 10.642 4.692 16.798 0 17.785-14.323 32.201-31.993 32.201-17.666 0-31.9888-14.416-31.9888-32.201v-71.5786l-13.5971-7.9001v79.4787c0 25.341 20.409 45.883 45.5859 45.883z" />
      <path d="m90.0001 135.079c15.5159 0 28.0989-12.66 28.0989-28.281 0-10.4121-5.593-19.5129-13.913-24.4227l-.137-.0765-.186-.1071-20.595-11.9687v15.804l13.9543 8.1066.0266.0153c4.3381 2.5238 7.2561 7.2461 7.2561 12.6491 0 8.061-6.4925 14.6-14.5049 14.6-8.0086 0-14.5051-6.539-14.5051-14.6v-61.4147l-13.5934-7.9001v69.3148c0 15.621 12.5828 28.281 28.0985 28.281z" />
    </g>
  </svg>
);

export default BestWaterAppIcon;
